<template>
    <div class="flex flex-col gap-8">
        <page-header class="mb-0!">Shift To Text</page-header>

        <shift-to-text-outbound-message />
        <shift-to-text-sounds></shift-to-text-sounds>
        <shift-to-text-redirect />
    </div>
</template>

<script setup>
import ShiftToTextOutboundMessage from './ShiftToTextOutboundMessage.vue';
import ShiftToTextRedirect from './ShiftToTextRedirect.vue';
import ShiftToTextSounds from './ShiftToTextSounds.vue';
import PageHeader from '~/components/general/PageHeader.vue';
</script>
